/* eslint-disable @nx/enforce-module-boundaries */
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { AxiosError } from 'axios';
import { QueryClient, MutationCache, QueryCache, QueryClientProvider } from '@tanstack/react-query';

import './sentry';
import App from './app/app';
import { AuthProvider } from './pages';
import { handleError } from './common/handleError';

import 'react-toastify/dist/ReactToastify.css';
import './styles.css';
import '../../../node_modules/@unbooking/ui-kit/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
    },
  },
  queryCache: new QueryCache({
    onError: error => handleError(error as AxiosError, true),
  }),
  mutationCache: new MutationCache({
    onError: error => handleError(error as AxiosError, true),
  }),
});

root.render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
